import { useRenderContext } from '@/lib/render/RenderContextProvider';

export function SchoolTypesComponent() {
  const { entities } = useRenderContext();
  const schoolTypes = (entities.location?.schoolTypes as string[]) ?? [];

  if (schoolTypes.length === 0) {
    return null;
  }

  return (
    <section className="pt-4">
      <div className="text-center">
        <p>{schoolTypes.join(', ')}</p>
      </div>
    </section>
  );
}
